import { useReadableEventLocationText } from "hooks/useReadableEventLocationText";

interface ReadableEventLocationTextProps {
  className?: string;
  text?: string;
}

export function ReadableEventLocationText({
  className,
  text,
}: ReadableEventLocationTextProps) {
  const readableText = useReadableEventLocationText(text);

  if (!readableText) {
    return null;
  }

  return <span className={className}>{readableText}</span>;
}
